import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { countries } from '../Countries';

export const useCountries = () =>
  useQuery({
    queryKey: [QUERY_KEYS.countries],
    queryFn: async () => (await countries.getCountries()).data,
  });
